import { ReportState } from './types';
import { GetterTree } from 'vuex';
import { RootState } from '../../types';

export const getters: GetterTree<ReportState, RootState> = {
  ['getReport']: state => state.report,
  ['getReportIsLoading']: state => state.loading,
};
